import { WechatBeanAccount } from "./WechatBeanAccount"
import { ThirdAccount } from "./ThirdAccount"
import { QQConnectAccount } from "./QQConnectAccount"
import { WechatAccount } from "./WechatAccount"
import { PskeyAccount } from "./PskeyAccount"
import { SkeyAccount } from "./SkeyAccount"

const pskey = "pskey_"
const uin = "uin"
const skey = "skey"

export class CommonAccount {
  init(opt) {
    return new Promise(async (resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = null
        let account = null
        try {
          // 微信豆登录态
          if (opt.session_type === "st_local_wechat") {
            account = new WechatBeanAccount(opt)
            loginState = await account.init(opt)
          }
          // wx登录态
          if (opt.session_id == "hy_gameid" && opt.session_type == "wc_actoken") {
            account = new WechatAccount(opt)
            loginState = await account.init(opt)
          }
          // 第三方登录态
          if (opt.session_type === "st_local_third_party") {
            account = new ThirdAccount(opt)
            loginState = await account.init(opt)
          }
          // QQ互联登录态
          if (opt.session_type === "kp_accesstoken" || opt.session_type === "kp_actoken") {
            account = new QQConnectAccount(opt)
            loginState = await account.init(opt)
          }
          // pskey登录态
          if (opt.session_id === uin && opt.session_type.indexOf(pskey) > -1) {
            account = new PskeyAccount(opt)
            loginState = await account.init(opt)
          }
          // skey登录态
          if (opt.session_id === uin && opt.session_type === skey) {
            account = new SkeyAccount(opt)
            loginState = await account.init(opt)
          }
          resolve(loginState)
        } catch (err) {
          reject("无登录态")
        }
      } else {
        reject("无登录态")
      }
    })
  }
}
